import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoutesAll } from 'src/app/Constants/app.constants';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class EntityDeatilPageGuard implements CanActivate {

	constructor(private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (!route.queryParamMap.has('pan') || !route.queryParamMap.has('entity_id')) {
			this.router.navigate([RoutesAll.authenication]);
		}
		return true;
	}
}